import { ChangeDetectionStrategy, Component } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';
import { SideMenuComponent } from './component/side-menu/side-menu.component';
import { HeaderComponent } from './component/header/header.component';
import { ToastModule } from 'primeng/toast';
import { LoadingOverlayComponent } from '@shared/components/loading-overlay/loading-overlay.component';

@Component({
    selector: 'app-layout',
    standalone: true,
    imports: [CommonModule, RouterModule, SideMenuComponent, HeaderComponent, ToastModule, LoadingOverlayComponent],
    templateUrl: './layout.component.html',
    styleUrls: ['./layout.component.scss'], // styleUrl -> styleUrls
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class LayoutComponent {
    // Layout component logic will go here if needed
}
